// RYSUNEK MONETY — jedno miejsce na cały produkt (dopisek koordynatora nr 2, 21.09).
//
// WARIANT 6 z rundy Claude Design 32-R5c. Właściciel obejrzał monetę z dwiema nutami (wariant 5)
// na telefonie i zdecydował: „na logo coina daj jedną nutkę jednak i wyśrodkuj ją. tę nutkę E.
// z ogonkiem”. Moneta jest PEŁNA, a w niej JEDNA nuta E z chorągiewką, wyśrodkowana optycznie
// (środek ciężkości całej nuty: główka, laska i chorągiewka razem, w (12,00; 12,00) na siatce 24).
// Pliki źródłowe: `design/claude-design-wyniki/32-minimal-muzyka-tekst/src/glify-token/
// token-6-moneta-jedna-nuta-E.svg` i `token-6-maly-16.svg`, arkusz `T2c`.
//
// DLATEGO TEN PLIK MA DOKŁADNIE DWIE STAŁE. Podmiana rysunku jest zmianą dwóch łańcuchów,
// a nie wyprawą po trzech plikach (to już trzecia podmiana jednego dnia): waluta rysuje się
// w aplikacji (`ds/media/Glyph`) i na stronach publicznych (`components/public/glyphs37`),
// a oba miejsca czytają stąd.
//
// NUTA JEST OTWOREM, NIE DRUGIM KOLOREM. Krążek i nuta są JEDNĄ ścieżką, w której nuta biegnie
// w przeciwną stronę niż okrąg, więc przy zwijaniu `nonzero` jest dziurą tak samo jak przy
// `evenodd` projektu. Znak bierze JEDEN kolor (`currentColor`) i tło prześwituje przez nutę —
// także na gradiencie przycisku „Wygeneruj”.

/**
 * Moneta na siatce 24 — rozmiary od 20 px w górę. Krążek r 11; jedna nuta E: główka to
 * elipsa 3,3 × 2,55 obrócona o 20°, laska 2,2 px, chorągiewka jednym obrysem z laską.
 */
export const TOKEN_COIN =
  'M12 1a11 11 0 1 0 0 22a11 11 0 1 0 0 -22z'
  + 'M11.59 13.02V4.04H13.79c0.7 3.3 4.7 3.7 4 8.4c0.3 -3 -2.1 -4 -4 -4.8V15.2A3.3 2.55 -20 1 1 11.59 13.02z'

/**
 * Moneta na siatce 16 — PONIŻEJ 20 px. Świadome uproszczenie, nie przeskalowanie:
 * główka jest KOŁEM (r 2,15), laska ma 1,6 px, a chorągiewka jest krótkim ukośnym zębem.
 */
export const TOKEN_COIN_SMALL =
  'M8 0.25a7.75 7.75 0 1 0 0 15.5a7.75 7.75 0 1 0 0 -15.5z'
  + 'M7.53 8.27V2.75H9.13l2.5 3.2v1.9l-2.5 -3.2V10.35A2.15 2.15 0 1 1 7.53 8.27z'
